import { common } from '@rchh/lowcode-engine';
import enUS from './en-US.json';
import zhCN from './zh-CN.json';

const fallbackMessages: Record<string, string> = zhCN;

const { intl } = common?.utils?.createIntl?.({
  'en-US': enUS,
  'zh-CN': zhCN,
}) || {
  intl: (id: string) => {
    return fallbackMessages[id];
  }
};

export { intl };
